import log from 'loglevel';
import { isSameDay } from 'date-fns';
import styled from '@emotion/styled';
import {
	ITimeSelectProps,
	TimeSelect,
} from '../../../../components/common/time-select/TimeSelect';
import { MaybeDate } from '../../../../components/common/date-picker/MaybeDate';
import { getDefaultTimeItem, timeOptions } from './options';
import { createTime, getTimeInMinutes } from '../../../../utils/dateTime';
import { Css, Responsive } from '../../../../ui';

export interface IEntryTimeSelectProp extends Omit<ITimeSelectProps, 'items'> {
	entryDate?: MaybeDate;
	minimumEntryDate: Date | null;
}

export const EntryTimeSelect = ({
	entryDate,
	minimumEntryDate,
	selectedItem,
	...rest
}: IEntryTimeSelectProp) => {
	const filteredItems = getEntryTimeOptions(minimumEntryDate, entryDate);
	const defaultTimeItem = getDefaultTimeItem(
		filteredItems,
		selectedItem?.value,
	);

	return (
		<StyledTimeSelect
			defaultScrollToNthItem={defaultTimeItem}
			placeholderAsLabel
			items={filteredItems}
			selectedItem={selectedItem}
			{...rest}
		/>
	);
};

const StyledTimeSelect = styled(TimeSelect)`
	min-width: ${Css.pxToRem(240)};
	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		width: 100%;
	}
	grid-area: entrytime;
`;

export const getEntryTimeOptions = (
	minimumDate: Date | null,
	entryDate?: MaybeDate,
) => {
	if (!entryDate || !minimumDate) return timeOptions;

	if (entryDate > minimumDate) return timeOptions;

	// NB: this should actually never happen when the date selection validation is working properly
	if (!isSameDay(entryDate, minimumDate)) {
		log.warn('Invalid entry date was provided');
		return [];
	}

	const minimumTotalMinutes = getTimeInMinutes(createTime(minimumDate));

	return timeOptions.filter(
		(timeOption) => timeOption.timeInMinutes >= minimumTotalMinutes,
	);
};
